import { render, staticRenderFns } from "./dataViewUp.vue?vue&type=template&id=3e36b43e&scoped=true&lang=pug"
import script from "./dataViewUp.vue?vue&type=script&lang=js"
export * from "./dataViewUp.vue?vue&type=script&lang=js"
import style0 from "./dataViewUp.vue?vue&type=style&index=0&id=3e36b43e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36b43e",
  null
  
)

export default component.exports